export default __webpack_public_path__ + "freeskuimage.0a17fc1.png";